import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ObjectFieldSelectOptionsEntity } from './object-field-select-options.entity';
import { ObjectFieldValidatorEntity } from './object-field-validator.entity';
import { ObjectFormatterObjectFieldEntity } from './object-formatter-object-field.entity';
import { ObjectEntity } from './object.entity';
import { PreferenceDetailEntity } from './preference-detail.entity';
import { SelectableResourceConfigurationEntity } from './selectable-resource-configuration.entity';

@Index(
	'_object_field__fk__object__id__fieldname_unique',
	['fkObjectId', 'fieldName'],
	{ unique: true },
)
@Index('_object_field__fk__object_field__id_foreign', ['fkObjectFieldId'], {})
@Entity('_object_field')
export class ObjectFieldEntity extends BaseEntity {
	@Column('int', { name: '_fk__object__id', nullable: true, unsigned: true })
	public fkObjectId!: number | null;

	@Column('varchar', { name: '_fieldName', nullable: true, length: 255 })
	public fieldName!: string | null;

	@Column('varchar', { name: '_type', nullable: true, length: 255 })
	public type!: string | null;

	@Column('int', {
		name: '_fk__object_field__id',
		nullable: true,
		unsigned: true,
	})
	public fkObjectFieldId!: number | null;

	@Column('varchar', { name: 'label', nullable: true, length: 255 })
	public label!: string | null;

	@Column({ type: 'boolean', name: 'readOnly', width: 1, default: () => "'0'" })
	public readOnly!: boolean;

	@Column({ type: 'boolean', name: '_searchable', width: 1, default: () => "'0'" })
	public searchable!: boolean;

	@Column({
		type: 'boolean',
		name: '_searchableInParent',
		width: 1,
		default: () => "'0'",
	})
	public searchableInParent!: boolean;

	@Column({
		type: 'boolean',
		name: '_searchableForeignKey',
		width: 1,
		default: () => "'0'",
	})
	public searchableForeignKey!: boolean;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@ManyToOne(
		() => ObjectFieldEntity,
		(objectField) => objectField.objectFields,
		{
			onDelete: 'CASCADE',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__object_field__id', referencedColumnName: 'id' }])
	public fkObjectField!: ObjectFieldEntity;

	@OneToMany(
		() => ObjectFieldEntity,
		(objectField) => objectField.fkObjectField,
		{},
	)
	public objectFields!: Array<ObjectFieldEntity>;

	@ManyToOne(() => ObjectEntity, (object) => object.objectFields, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__object__id', referencedColumnName: 'id' }])
	public fkObject!: ObjectEntity;

	@OneToMany(
		() => ObjectFieldSelectOptionsEntity,
		(objectFieldSelectOptions) => objectFieldSelectOptions.fkObjectField,
		{ cascade: true },
	)
	public objectFieldSelectOptions!: Array<ObjectFieldSelectOptionsEntity>;

	@OneToMany(
		() => ObjectFieldValidatorEntity,
		(objectFieldValidator) => objectFieldValidator.fkObjectField,
		{ cascade: true },
	)
	public objectFieldValidators!: Array<ObjectFieldValidatorEntity>;

	@OneToMany(
		() => ObjectFormatterObjectFieldEntity,
		(objectFormatterObjectField) => objectFormatterObjectField.fkObjectField,
		{ cascade: true },
	)
	public objectFormatterObjectFields!: Array<ObjectFormatterObjectFieldEntity>;

	@OneToMany(
		() => PreferenceDetailEntity,
		(preferenceDetail) => preferenceDetail.fkObjectField,
		{},
	)
	public preferenceDetails!: Array<PreferenceDetailEntity>;

	@OneToMany(
		() => SelectableResourceConfigurationEntity,
		(selectableResourceConfiguration) =>
			selectableResourceConfiguration.fkObjectField,
		{},
	)
	public selectableResourceConfigurations!: Array<SelectableResourceConfigurationEntity>;
}
